/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EligibleResult } from './eligibleResult';


export interface CompleteOrderAssessedItemApiModel { 
    id: number;
    note?: string | null;
    result: EligibleResult;
    period: number;
}
export namespace CompleteOrderAssessedItemApiModel {
}


